import { render, staticRenderFns } from "./DeclaracaoConcessionaria.vue?vue&type=template&id=07ea96bd&scoped=true&"
import script from "./DeclaracaoConcessionaria.vue?vue&type=script&lang=js&"
export * from "./DeclaracaoConcessionaria.vue?vue&type=script&lang=js&"
import style0 from "./DeclaracaoConcessionaria.vue?vue&type=style&index=0&id=07ea96bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ea96bd",
  null
  
)

export default component.exports